import { useSelector } from "react-redux";
import {
  getMappingNotifications,
  getMappingNotificationsByDatasourceId,
  getSystemNotificationMessages,
  getSystemNotificationsFetchStatus,
} from "./selectors";
import { DataSourceId } from "../../../globalTypes";

export const useSystemNotificationsFetchStatus = () =>
  useSelector(getSystemNotificationsFetchStatus);

export const useSystemNotificationMessages = () =>
  useSelector(getSystemNotificationMessages);

export const useMappingNotifications = () =>
  useSelector(getMappingNotifications);

export const useMappingNotificationsByDatasourceId = () =>
  useSelector(getMappingNotificationsByDatasourceId) ?? {};

export const useMappingNotificationsForDatasourceId = (id: DataSourceId) =>
  useSelector(getMappingNotificationsByDatasourceId)[id] ?? [];

export const useMappingNotificationIds = (id: DataSourceId) =>
  useMappingNotificationsForDatasourceId(id).map(
    ({ notificationId }) => notificationId
  );
